import React, { useState } from 'react'
import { com } from '@eidu/web'
import MAX_KEY_LENGTH = com.eidu.sharedlib.form.validation.MAX_KEY_LENGTH
import FormKeyValidator = com.eidu.sharedlib.form.validation.FormKeyValidator
import TrimmedTextInput from './TrimmedTextInput'

export type FormKeyFieldProp = {
  disabled: boolean
  value: string
  label?: string
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  fullWidth?: boolean
}

const FormKeyField: React.FC<FormKeyFieldProp> = ({
  value,
  label = 'Key',
  fullWidth = false,
  onChange,
  disabled = false,
}) => {
  const [keyValue, setKeyValue] = useState(value)
  const [keyLength, setKeyLength] = useState(value.length)
  const [isValidKey, setIsValidKey] = useState(FormKeyValidator.isValidKey(value))

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const text = event.target.value

    const valid = FormKeyValidator.isValidKey(text)
    setIsValidKey(valid)

    setKeyValue(text)
    setKeyLength(text.length)
    onChange(event)
  }

  return (
    // Shrinkable in flex rows so narrow panels don't overflow; the input scrolls its text internally.
    <div style={{ display: 'flex', flexDirection: 'column', width: 300, minWidth: 160, flexShrink: 1 }}>
      <TrimmedTextInput
        label={label}
        value={keyValue}
        onChange={handleChange}
        styles={{ input: { fontFamily: 'monospace' } }}
        description={`${keyLength} / ${MAX_KEY_LENGTH}`}
        w={fullWidth ? '100%' : undefined}
        disabled={disabled}
        error={!isValidKey}
      />
    </div>
  )
}

export default FormKeyField
